import React, { useContext, useEffect, useRef } from "react";
import Head from "next/head";
import ReactPaginate from "react-paginate";

import { getGamesForPlatform, getAppsForPlatform } from "../../utils/api";
import { Context } from "../../context";
import { pageStyle, mediumFont } from "../../utils/styles";
import { PlatformIcon } from "../../utils/icons";
import Layout from "../../components/Layout";
import BannerAd from "../../components/BannerAd";
import ItemsGrid from "../../components/ItemsGrid";
import Page404 from "../404";

const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop - 15);

const Platform = ({ games, apps, slug, }) => {
  const contentRef = useRef(null);
  const { menu } = useContext(Context);

  const platform = menu.platforms.find((p) => p.slug === slug);
  if (!platform) {
    return <Page404 />
  }

  useEffect(() => {
    if (games.length > 0) {
      const lazyItems = [].slice.call(document.querySelectorAll(".games img"));
      function loadItems(e) {
        setTimeout(function () {
          if (lazyItems.length) {
            lazyItems.forEach(function (lazyItem) {
              lazyItem.setAttribute("src", lazyItem.getAttribute("data-src"));
            });
          }
        }, 500);
        window.removeEventListener("scroll", loadItems);
      }
      window.addEventListener("scroll", loadItems);

      if (contentRef.current) {
        scrollToRef(contentRef);
      }
    }
  }, [games]);

  return (
    <Layout noAds>
      <Head>
        <title>{`${platform.name} Games  - AppCheeta`}</title>
      </Head>
      <div className="page-content">
        <style jsx>{pageStyle}</style>
        <style jsx>{`
          .section {
            margin-top: 2rem;
            margin-bottom: 2.5rem;
          }
          .section-content {
            margin-bottom: 2rem;
          }
          .subtitle {
            font-size: ${mediumFont};
            font-weight: bold;
            margin-bottom: 1.5rem;
          }
          .section-title {
            font-weight: 700;
            margin-top: 1.5rem;
            margin-bottom: 0.75rem;
          }
        `}</style>
        <BannerAd />
        <div className="section games" ref={contentRef}>
          <h2 className="subtitle">
            <PlatformIcon />&nbsp;&nbsp;{platform.name}
          </h2>
          <div className="section-content">
            <h3 className="section-title">Games</h3>
            <ItemsGrid items={games} path="game" categorized={false} width={70} />
            <h3 className="section-title">Apps</h3>
            <ItemsGrid items={apps} path="app" categorized={false} width={70} />
          </div>
        </div>
      </div>
    </Layout>
  );
};

Platform.getInitialProps = async ({ query, cached }) => {
  const { slug } = query;
  const {
    games,
  } = await getGamesForPlatform({ slug, cached });
  const {
    apps,
  } = await getAppsForPlatform({ slug, cached });

  const analytics = {
    content_group1: "Platform", // Page Type
  };
  return { games, apps, slug, analytics };
};

export default Platform;
